import 'core-js/features/object';
import 'core-js/features/array';
import 'core-js/features/number/is-finite';
import 'core-js/features/number/parse-int';
import 'core-js/features/string/starts-with';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';

unregister();
ReactDOM.render(<App />, document.getElementById('eclisse-configurator'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js